import { styled } from '@material-ui/core/styles'

import { colors, newColors } from 'artkive/utils/theme'

export const SectionWrapper = styled('div')({
  position: 'relative',
  overflow: 'hidden',
  backgroundColor: newColors.sky[100],
  // 64px gap between consecutive sections; the first one gets none.
  '& + &': {
    marginTop: '64px',
  },
})

export const ColorFill = styled('div')({
  height: '100%',
  '&[data-fill="0"]': { backgroundColor: colors.bg.blue },
  '&[data-fill="1"]': { backgroundColor: colors.bg.pink_med },
  '&[data-fill="2"]': { backgroundColor: colors.bg.yellow },
})

export const ContentCard = styled('div')(({ theme }) => ({
  position: 'relative',
  maxWidth: '700px',
  [theme.breakpoints.up('md')]: {
    position: 'absolute',
    top: '50%',
    right: '10%',
    transform: 'translate(0, -50%)',
    '&[data-mirrored]': {
      right: 'auto',
      left: '10%',
    },
  },
}))

export const CardPadding = styled('div')(({ theme }) => ({
  padding: '16px',
  [theme.breakpoints.up('md')]: {
    padding: '80px',
  },
}))
